<template>
    <div v-if="show_loading" class="loading-screen">
        <div style="height: 150px;" class="image-holder" v-if="images.length > 0">
            <img v-if="images[currentNumber] !== undefined"  style="height: 100%; width: auto;" :src="images[currentNumber].thumb" />
        </div>
        <h2 v-text="text"></h2>
    </div>
</template>
<script>
export default {
    props: ['images','text','show'],
    mounted() {
        let vm = this;

        if( vm.show == 0 )
        {
            vm.show_loading = false;
            this.stopRotation();
        }

        this.startRotation();
        setTimeout(() => {
            vm.show_loading = false;
            this.stopRotation();
            Event.$emit('endpoint_loaded');
            $('#quiz-campaign').removeClass('loading');
        }, 5000);

        Event.$on('trigger_loading', ($event) => {
            vm.show_loading = true;
            vm.startRotation();
        });

        Event.$on('endpoint_changed', ($event) => {
            vm.show_loading = $event.loading;
            if(vm.show_loading===true){
                this.startRotation();
            }
            setTimeout(() => {
                vm.show_loading = false;
                this.stopRotation();
            }, 5000)
        });
    },
    methods: {
        startRotation() {
            this.timer = setInterval(this.next, 250);
        },
        stopRotation() {
            clearTimeout(this.timer);
            this.timer = null;
        },
        next() {
            if( this.currentNumber < this.images.length ){
               this.currentNumber += 1;
            } else {
                this.currentNumber = 0;
            }

        }
    },
    data() {
        return {
            show_loading: true,
            endpoint: null,
            product: null,
            currentNumber: 0,
            timer: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/loading-screen.vue